let todo = {
  title: "我的待办",

  columns: {
    toDoItems: "待办事项",
    emergency: "紧急状况",
    taskContent: "任务内容",
    taskState:"任务状态",
    taskStateText:'待处理',
    taskStateTextEnd:'已处理',
    taskInitiator: "任务发起人",
    taskSendingTime: "任务发起时间",
    action: "操作",
    actionText:"去处理"
  },
  details:{
    todoDetails:"待办详情",
    toDoItems: "待办事项",
    taskState:"任务状态",
    taskInitiator: "任务发起人",
    taskSendingTime: "任务发起时间",
  },
  tabItem:{
    item1:'待办事项',
    item2:'已办事项',
  }


}

export default todo
